import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { BackButtonProvider } from '../../back-button.provider';

@Component({
  selector: 'cdf-back-button-provider',
  imports: [],
  template: `<ng-content />`,
  styles: `
    :host {
      display: contents;
    }
  `,
  providers: [
    // Provide this component as the BackButtonProvider
    { provide: BackButtonProvider, useFactory: () => inject(BackButtonProviderComponent) },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonProviderComponent implements BackButtonProvider {
  readonly label = input<string | undefined>(undefined);
  readonly back = output<void>();

  readonly backButton = computed(() => {
    const label = this.label();
    if (label) {
      return { label, action: () => this.back.emit() };
    }
    return undefined;
  });
}
